import type { InputHTMLAttributes, Ref } from 'react';

import { cn } from 'src/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const Input = ({
  className,
  type,
  ref,
  ...props
}: InputProps & { ref?: Ref<HTMLInputElement> }) => {
  return (
    <input
      className={cn(
        'flex h-10 w-full rounded-md border-border-default bg-layout px-3 py-2 text-layout-foreground text-sm placeholder:text-layout-foreground-secondary focus:border-border-default focus:ring-2 focus:ring-primary-focus focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        'file:border-0 file:bg-transparent file:font-medium file:text-layout-foreground-title file:text-sm',
        '[&::-webkit-search-cancel-button]:hidden',
        '[&::-webkit-search-decoration]:hidden',
        className,
      )}
      ref={ref}
      type={type}
      {...props}
    />
  );
};
Input.displayName = 'Input';

export { Input };
